<template>
  <label>
    <span>{{ $t("Show") }}:</span>
    <select2
      class="select2"
      v-model.number="perPage"
      :options="perPageOptions"
      :settings="perPageSettings"
      @change="ChangeEvent($event)"
      @select="SelectEvent($event)"
    />
  </label>
</template>

<script>
import Select2 from "v-select2-component";
import { PerPage } from "@/configure/index";
export default {
  name: "PerPageTable",
  components: {
    Select2,
  },
  data() {
    return {
      perPageOptions: PerPage(),
      perPageSettings: {
        minimumResultsForSearch: Infinity,
      },
      perPage: 10,
    };
  },
  methods: {
    ChangeEvent(val) {
      this.$emit("per-page", val);
    },
    SelectEvent({ id, text }) {},
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/central/account/referfriends/PerPage.vue